import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "flex flex-wrap items-center gap-3"
};
const _hoisted_4 = {
  class: "list-page-segmented"
};
const _hoisted_5 = {
  key: 0,
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_6 = {
  class: "filter-bar-field is-wide relative"
};
const _hoisted_7 = {
  class: "data-table-shell"
};
const _hoisted_8 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_9 = {
  class: "data-table text-sm"
};
const _hoisted_10 = {
  class: "data-table-td"
};
const _hoisted_11 = {
  class: "text-sm font-medium text-slate-800 break-all"
};
const _hoisted_12 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_13 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_14 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_15 = {
  class: "text-sm text-slate-600"
};
const _hoisted_16 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_17 = {
  class: "text-sm text-slate-600"
};
const _hoisted_18 = {
  class: "data-table-td whitespace-nowrap"
};
const _hoisted_19 = {
  class: "data-table-td is-center whitespace-nowrap data-table-sticky-right data-table-sticky-action"
};
const _hoisted_20 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = ["onClick"];
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  key: 0,
  class: "empty-state"
};
const _hoisted_27 = {
  key: 1,
  class: "flex items-center justify-center py-12"
};
import { ref, computed, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useUserStore } from '@/stores/user';
import { meetingApi } from '@/api/meeting';
import { formatDateTime } from '@/utils/dateFormat';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import MeetingFormModal from './components/MeetingFormModal.vue';
import MeetingDetailDrawer from './components/MeetingDetailDrawer.vue';
import MyActionItemList from './components/MyActionItemList.vue';
import MeetingStatsPanel from './components/MeetingStatsPanel.vue';

// Tab 状态

export default {
  __name: 'index',
  setup(__props) {
    const activeTab = ref('meetings');

    // 列表数据
    const loading = ref(false);
    const meetingList = ref([]);
    const pagination = ref({
      current: 1,
      size: 10,
      total: 0,
      pages: 0
    });

    // 筛选条件
    const searchKeyword = ref('');
    const filterType = ref('');
    const filterStatus = ref('');
    const timeRange = ref(null);

    // 弹窗/抽屉状态
    const showFormModal = ref(false);
    const editingMeeting = ref(null);
    const showDetailDrawer = ref(false);
    const currentMeetingId = ref(null);
    const detailDrawerRef = ref(null);

    // 归属判断：会议管理操作仅组织者/主持人可见（后端归属授权强制，此处只做 UI 显隐）
    const userStore = useUserStore();
    const currentUserId = computed(() => userStore.userInfo?.userId);
    const isMeetingManager = row => {
      if (currentUserId.value == null) return false;
      return Number(row.organizerId) === Number(currentUserId.value) || Number(row.hostId) === Number(currentUserId.value);
    };

    // 状态/类型徽章颜色映射（文案直接使用后端 desc 字段）
    const MEETING_STATUS_CLASS = {
      PLANNED: 'is-info',
      ENDED: 'is-neutral',
      CANCELLED: 'is-danger'
    };
    const MEETING_TYPE_CLASS = {
      INTERNAL: 'is-teal',
      CUSTOMER: 'is-indigo'
    };
    const MEETING_MODE_CLASS = {
      OFFLINE: 'is-neutral',
      ONLINE: 'is-cyan',
      HYBRID: 'is-indigo'
    };

    // 获取会议列表
    const fetchMeetingList = async () => {
      loading.value = true;
      try {
        const params = {
          page: pagination.value.current,
          size: pagination.value.size,
          keyword: searchKeyword.value || undefined,
          meetingType: filterType.value || undefined,
          status: filterStatus.value || undefined,
          startTimeFrom: timeRange.value?.[0] || undefined,
          startTimeTo: timeRange.value?.[1] || undefined
        };
        // 移除 undefined 值
        Object.keys(params).forEach(key => {
          if (params[key] === undefined) delete params[key];
        });
        const data = await meetingApi.getMeetingList(params);
        // request 拦截器已解包，data 直接是分页业务体
        meetingList.value = data?.records || [];
        pagination.value = {
          current: Number(data?.current) || 1,
          size: Number(data?.size) || 10,
          total: Number(data?.total) || 0,
          pages: Number(data?.pages) || 0
        };
      } catch (error) {
        ElMessage.error('获取会议列表失败');
        console.error('获取会议列表失败:', error);
      } finally {
        loading.value = false;
      }
    };
    const handleFilterChange = () => {
      pagination.value.current = 1;
      fetchMeetingList();
    };
    const handleSearch = () => {
      pagination.value.current = 1;
      fetchMeetingList();
    };
    const handleReset = () => {
      searchKeyword.value = '';
      filterType.value = '';
      filterStatus.value = '';
      timeRange.value = null;
      pagination.value.current = 1;
      fetchMeetingList();
    };
    const handlePageChange = page => {
      pagination.value.current = page;
      fetchMeetingList();
    };
    const handlePageSizeChange = size => {
      pagination.value.size = size;
      pagination.value.current = 1;
      fetchMeetingList();
    };

    // 新建会议
    const handleCreate = () => {
      editingMeeting.value = null;
      showFormModal.value = true;
    };

    // 编辑会议（列表行无参会人，先拉详情取 attendeeUserIds 再打开弹窗）
    const handleEdit = async row => {
      try {
        const detail = await meetingApi.getMeetingDetail(row.id);
        editingMeeting.value = {
          ...row,
          attendeeUserIds: (detail?.attendees || []).map(a => a.userId)
        };
        showFormModal.value = true;
      } catch (error) {
        // 拦截器已提示
        console.error('获取会议详情失败:', error);
      }
    };

    // 表单保存成功：刷新列表；若详情抽屉仍打开（抽屉内编辑场景），同步刷新抽屉详情
    const handleFormSaved = () => {
      showFormModal.value = false;
      fetchMeetingList();
      if (showDetailDrawer.value) {
        detailDrawerRef.value?.fetchDetail?.();
      }
    };

    // 打开详情抽屉
    const handleOpenDetail = row => {
      currentMeetingId.value = row.id;
      showDetailDrawer.value = true;
    };

    // 我的决策项点击所属会议，打开对应会议详情抽屉
    const handleOpenMeeting = meetingId => {
      currentMeetingId.value = meetingId;
      showDetailDrawer.value = true;
    };

    // 取消会议
    const handleCancel = async row => {
      try {
        await ElMessageBox.confirm(`确定要取消会议「${row.title}」吗？`, '提示', {
          type: 'warning'
        });
        await meetingApi.cancelMeeting(row.id);
        ElMessage.success('会议已取消');
        fetchMeetingList();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('取消会议失败');
          console.error('取消会议失败:', error);
        }
      }
    };

    // 结束会议
    const handleEnd = async row => {
      try {
        await ElMessageBox.confirm(`确定要结束会议「${row.title}」吗？`, '提示', {
          type: 'warning'
        });
        await meetingApi.endMeeting(row.id);
        ElMessage.success('会议已结束');
        fetchMeetingList();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('结束会议失败');
          console.error('结束会议失败:', error);
        }
      }
    };

    // 删除会议（仅无决策项、物料、纪要的待召开会议可删除）
    const handleDelete = async row => {
      try {
        await ElMessageBox.confirm(`确定要删除会议「${row.title}」吗？仅无决策项、物料、纪要的待召开会议可删除。`, '提示', {
          type: 'warning'
        });
        await meetingApi.deleteMeeting(row.id);
        ElMessage.success('会议已删除');
        fetchMeetingList();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('删除会议失败');
          console.error('删除会议失败:', error);
        }
      }
    };
    onMounted(fetchMeetingList);
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[10] || (_cache[10] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "会议管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "跟踪会议安排、决策项与会议纪要")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("button", {
          type: "button",
          class: _normalizeClass(['list-page-segmented-item', {
            'is-active': activeTab.value === 'meetings'
          }]),
          onClick: _cache[0] || (_cache[0] = $event => activeTab.value = 'meetings')
        }, " 全部会议 ", 2), _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(['list-page-segmented-item', {
            'is-active': activeTab.value === 'mine'
          }]),
          onClick: _cache[1] || (_cache[1] = $event => activeTab.value = 'mine')
        }, " 我的决策项 ", 2), _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(['list-page-segmented-item', {
            'is-active': activeTab.value === 'stats'
          }]),
          onClick: _cache[2] || (_cache[2] = $event => activeTab.value = 'stats')
        }, " 统计 ", 2)]), _createElementVNode("button", {
          type: "button",
          class: "btn-primary inline-flex items-center gap-2",
          onClick: handleCreate
        }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M12 4v16m8-8H4"
        })], -1), _createTextVNode(" 新建会议 ", -1)]))])])])])]),
        default: _withCtx(() => [activeTab.value === 'meetings' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: fetchMeetingList
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, " 搜索 "), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleReset
          }, " 重置 ")]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => searchKeyword.value = $event),
            type: "text",
            placeholder: "搜索会议主题",
            class: "form-search-input form-control-sm w-full",
            onKeyup: _withKeys(handleSearch, ["enter"])
          }, null, 544), [[_vModelText, searchKeyword.value]]), _cache[11] || (_cache[11] = _createElementVNode("svg", {
            class: "absolute left-3 top-2.5 h-4 w-4 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          })], -1))]), _createVNode(_component_el_select, {
            modelValue: filterType.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => filterType.value = $event),
            placeholder: "全部类型",
            class: "form-select form-control-sm filter-bar-field",
            onChange: handleFilterChange
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部类型",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "内部会议",
              value: "INTERNAL"
            }), _createVNode(_component_el_option, {
              label: "客户相关会议",
              value: "CUSTOMER"
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: filterStatus.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => filterStatus.value = $event),
            placeholder: "全部状态",
            class: "form-select form-control-sm filter-bar-field",
            onChange: handleFilterChange
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "待召开",
              value: "PLANNED"
            }), _createVNode(_component_el_option, {
              label: "已结束",
              value: "ENDED"
            }), _createVNode(_component_el_option, {
              label: "已取消",
              value: "CANCELLED"
            })]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
            modelValue: timeRange.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => timeRange.value = $event),
            type: "datetimerange",
            "range-separator": "至",
            "start-placeholder": "开始时间",
            "end-placeholder": "结束时间",
            "value-format": "YYYY-MM-DD HH:mm:ss",
            class: "form-date form-control-sm filter-bar-field is-wide",
            onChange: handleFilterChange
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("table", _hoisted_9, [_cache[17] || (_cache[17] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "会议主题"), _createElementVNode("th", {
          class: "data-table-th text-left w-28"
        }, "类型"), _createElementVNode("th", {
          class: "data-table-th text-left w-24"
        }, "方式"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "会议时间"), _createElementVNode("th", {
          class: "data-table-th text-left w-28"
        }, "组织者"), _createElementVNode("th", {
          class: "data-table-th text-left w-24"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meetingList.value, row => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_10, [_createElementVNode("p", _hoisted_11, _toDisplayString(row.title), 1)]), _createElementVNode("td", _hoisted_12, [_createElementVNode("span", {
            class: _normalizeClass(['status-badge', MEETING_TYPE_CLASS[row.meetingType] || 'is-neutral'])
          }, _toDisplayString(row.meetingTypeDesc || row.meetingType), 3)]), _createElementVNode("td", _hoisted_13, [_createElementVNode("span", {
            class: _normalizeClass(['status-badge', MEETING_MODE_CLASS[row.meetingMode] || 'is-neutral'])
          }, _toDisplayString(row.meetingModeDesc || row.meetingMode || '-'), 3)]), _createElementVNode("td", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_unref(formatDateTime)(row.startTime)) + " ~ " + _toDisplayString(_unref(formatDateTime)(row.endTime)), 1)]), _createElementVNode("td", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(row.organizerName || '-'), 1)]), _createElementVNode("td", _hoisted_18, [_createElementVNode("span", {
            class: _normalizeClass(['status-badge', MEETING_STATUS_CLASS[row.status] || 'is-neutral'])
          }, _toDisplayString(row.statusDesc || row.status), 3)]), _createElementVNode("td", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("button", {
            type: "button",
            class: "table-action-button is-primary",
            title: "详情",
            "aria-label": "详情",
            onClick: $event => handleOpenDetail(row)
          }, [...(_cache[12] || (_cache[12] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_21), row.status === 'PLANNED' && isMeetingManager(row) ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "table-action-button is-primary",
            title: "编辑",
            "aria-label": "编辑",
            onClick: $event => handleEdit(row)
          }, [...(_cache[13] || (_cache[13] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_22)) : _createCommentVNode("", true), row.status === 'PLANNED' && isMeetingManager(row) ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "table-action-button is-neutral",
            title: "取消",
            "aria-label": "取消",
            onClick: $event => handleCancel(row)
          }, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
          })], -1)]))], 8, _hoisted_23)) : _createCommentVNode("", true), row.status === 'PLANNED' && isMeetingManager(row) ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "table-action-button is-success",
            title: "结束",
            "aria-label": "结束",
            onClick: $event => handleEnd(row)
          }, [...(_cache[15] || (_cache[15] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M5 13l4 4L19 7"
          })], -1)]))], 8, _hoisted_24)) : _createCommentVNode("", true), row.status === 'PLANNED' && isMeetingManager(row) ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            type: "button",
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除",
            onClick: $event => handleDelete(row)
          }, [...(_cache[16] || (_cache[16] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_25)) : _createCommentVNode("", true)])])]);
        }), 128))])])])]), meetingList.value.length === 0 && !loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_cache[18] || (_cache[18] = _createElementVNode("div", {
          class: "empty-state-icon"
        }, [_createElementVNode("svg", {
          class: "h-7 w-7",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "1.5",
          d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
        })])], -1)), _cache[19] || (_cache[19] = _createElementVNode("p", {
          class: "empty-state-title"
        }, "暂无会议", -1)), _createElementVNode("button", {
          type: "button",
          class: "btn-primary mt-4",
          onClick: handleCreate
        }, " 立即创建 ")])) : _createCommentVNode("", true), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[20] || (_cache[20] = [_createElementVNode("svg", {
          class: "w-8 h-8 animate-spin text-primary-500",
          fill: "none",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("circle", {
          class: "opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          "stroke-width": "4"
        }), _createElementVNode("path", {
          class: "opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        })], -1)]))])) : _createCommentVNode("", true), pagination.value.pages > 1 ? (_openBlock(), _createBlock(AppPagination, {
          key: 2,
          class: "pagination-bridge",
          pagination: pagination.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["pagination"])) : _createCommentVNode("", true)])) : activeTab.value === 'mine' ? (_openBlock(), _createBlock(MyActionItemList, {
          key: 1,
          onOpenMeeting: handleOpenMeeting
        })) : activeTab.value === 'stats' ? (_openBlock(), _createBlock(MeetingStatsPanel, {
          key: 2
        })) : _createCommentVNode("", true), _createVNode(MeetingFormModal, {
          visible: showFormModal.value,
          meeting: editingMeeting.value,
          onClose: _cache[7] || (_cache[7] = $event => showFormModal.value = false),
          onSaved: handleFormSaved
        }, null, 8, ["visible", "meeting"]), _createVNode(MeetingDetailDrawer, {
          ref_key: "detailDrawerRef",
          ref: detailDrawerRef,
          modelValue: showDetailDrawer.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showDetailDrawer.value = $event),
          "meeting-id": currentMeetingId.value,
          onEdit: handleEdit,
          onRefresh: fetchMeetingList
        }, null, 8, ["modelValue", "meeting-id"])]),
        _: 1
      });
    };
  }
};